import React from 'react'
import { useTheme } from 'styled-components'
import Heading from '../../components/Heading/Heading'
import getThemeValue from '../../util/getThemeValue'
import { ModalBackButton, ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalTitle } from './styles'
import { ModalProps } from './types'

const Modal: React.FC<ModalProps> = ( {
                                        title,
                                        titleIcon,
                                        onDismiss,
                                        onBack,
                                        children,
                                        hideCloseButton = false,
                                        bodyPadding = '24px',
                                        headerBackground = 'transparent',
                                        titleColor = 'white',
                                        minWidth = '320px',
                                        ...props
                                      } ) => {
  const theme = useTheme()
  return (
    <ModalContainer minWidth={ minWidth } { ...props }>
      <ModalHeader background={ getThemeValue( `colors.${ headerBackground }`, headerBackground )( theme ) }>
        <ModalTitle>
          { onBack && <ModalBackButton onBack={ onBack }/> }
          { titleIcon && React.isValidElement( titleIcon ) && React.cloneElement<any>( titleIcon, { mr: '0.5em' } ) }
          <Heading color={ titleColor }>{ title }</Heading>
        </ModalTitle>
        { !hideCloseButton && <ModalCloseButton onDismiss={ onDismiss }/> }
      </ModalHeader>
      <ModalBody p={ bodyPadding }>{ children }</ModalBody>
    </ModalContainer>
  )
}

export default Modal
